import Manage from '@/views/pages/shortcodes/ShortcodesTable.vue'
import Report from '@/views/pages/shortcodes/report.vue'

export default [
  {
    path: '/shortcode-manage',
    name: 'shortcode-manage',
    component: Manage
  },
  {
    path: '/shortcode-usage-report',
    name: 'shortcode-usage-report',
    component: Report
  }
]
